export const SidebarData = [
    {
        title: 'Movimientos',
        path: '/movimientos',
        cName: 'nav-text',
        permission: 0,
        visibleTo: ["Recomotor"]
    },
    {
        title: 'Facturas a crédito',
        path: '/facturas',
        cName: 'nav-text',
        permission: 0,
        visibleTo: ["Recomotor","Desguace Mical", "Desguace Segohon"]
    },
    {
        title: 'Abonos',
        path: '/abonos',
        cName: 'nav-text',
        permission: 0,
        visibleTo: ["Recomotor","Desguace Mical", "Desguace Segohon"]
    },
    {
        title: 'Exportadores',
        path: '/exportadores',
        cName: 'nav-text',
        permission: 0,
        visibleTo: ["Recomotor"]
    },
    {
        title: 'BackOffice',
        path: '/backoffice',
        cName: 'nav-text',
        permission: 0,
        visibleTo: ["Recomotor"]
    }
]